// Address form field constants
export const TITLE = 'Title';
export const TYPE_ID = 'TypeId';
export const TYPE_TITLE = 'TypeTitle';
export const LINE1 = 'Line1';
export const LINE2 = 'Line2';
export const CITY = 'City';
export const PROVINCE = 'Province';
export const POSTAL_CODE = 'PostalCode';
export const COUNTRY = 'Country';
export const CUSTOMER_ID = 'CustomerId';
export const PATROL_TYPE = 'PatrolType';
export const INSTRUCTIONS = 'Instructions';
export const ONLINE_MAP_URL = 'OnlineMapUrl';

// Action types
export const RESET = 'RESET';
export const ADDRESS_CONVERT = 'ADDRESS_CONVERT';
